// @ts-check
import { TIMEZONE_MODES } from 'src/models/model/constants'
import { reactive } from 'vue'

/**
 * Used to determine when the app should fetch new data from the API.
 */
export const configurationStatus = reactive({
  areUnpushedChanges: false,
  /**
   * Only automatically push changes for POS. For admin, allow this as an option, but not the default.
   */
  automatic: false,
  isPushingConfigurationData: false,
  /** @type {number|null} */
  localClientConfigVersion: null,
  /** @type {number|null} */
  notifiedClientConfigVersion: null,
  unpushedChangeCount: 0,
  batchSaving: false
})

/**
 * Global setting for how we display time, in the site time or the local system time
 */
export const timezoneMode = reactive({
  value: TIMEZONE_MODES.SITE
})
// NOTE: `timeContainer` is defined in IsoDateTime.js due to the circular dependency.
